// philippinesV2TabConfig.ts
// ─── Astria Philippines v2 
import { AstriaPhilippinesV2Tab } from "./AstriaPhilippinesV2Shell";

export type PhilippinesV2FieldType =
  | "emoji_wheel"
  | "slider"
  | "chips"
  | "multi_select"
  | "text";

export interface PhilippinesV2FieldConfig {
  key:
    | "mood"
    | "intensity"
    | "connection"
    | "tone"
    | "flow"
    | "readiness"
    | "emotion_zone"
    | "location"
    | "issue"
    | "desired"
    | "latest_message"
    | "feeling";
  type: PhilippinesV2FieldType;
  optionValues?: string[];
}

export interface PhilippinesV2TabConfig {
  tab: AstriaPhilippinesV2Tab;
  icon: string; // emoji, per client spec
  fields: PhilippinesV2FieldConfig[];
}

export const PHILIPPINES_V2_TAB_CONFIGS: PhilippinesV2TabConfig[] = [
  {
    tab: "soft_summary",
    icon: "🌙",
    fields: [
      { key: "mood", type: "emoji_wheel" },
      { key: "intensity", type: "slider" },
    ],
  },
  {
    tab: "connection_atmosphere",
    icon: "💗",
    fields: [
      {
        key: "connection",
        type: "chips",
        optionValues: ["warm", "distant", "tense", "playful", "quiet"],
      },
      {
        key: "tone",
        type: "chips",
        optionValues: ["gentle", "guarded", "open", "unsure"],
      },
    ],
  },
  {
    tab: "timing_rhythm",
    icon: "⏳",
    fields: [
      {
        key: "flow",
        type: "chips",
        optionValues: ["slow", "steady", "rushed", "uncertain"],
      },
      { key: "readiness", type: "slider" },
    ],
  },
  {
    tab: "emotion_balance",
    icon: "🌤️",
    fields: [
      {
        key: "emotion_zone",
        type: "chips",
        optionValues: ["warm", "heavy", "light", "tender", "steady"],
      },
      {
        key: "location",
        type: "chips",
        optionValues: ["chest", "mind", "stomach", "everywhere"],
      },
    ],
  },
  {
    tab: "guidance_path",
    icon: "🧭",
    fields: [
      {
        key: "issue",
        type: "chips",
        optionValues: ["communication", "distance", "uncertainty", "overwhelm"],
      },
      {
        key: "desired",
        type: "chips",
        optionValues: ["clarity", "closeness", "peace", "courage"],
      },
    ],
  },
  {
    tab: "your_note",
    icon: "📝",
    fields: [
      { key: "latest_message", type: "text" },
      {
        key: "feeling",
        type: "chips",
        optionValues: ["soft", "hopeful", "unsure", "relieved"],
      },
    ],
  },
];